import React, { useEffect, useState } from "react";
import "./dashboard.css";
import Table from "../../constants/Table";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { STATUS_DROPDOWN, RFQ_STATUS, getStatusProps } from "../../constants/status";

import { DropdownButton, Dropdown } from "react-bootstrap";
import StatusBadge from "../../constants/statusBadge";

const buyerStatusOptions = [
  { label: "All", value: "" },
  { label: "Closed", value: "12" },
  { label: "Created", value: "0" },
  { label: "Live", value: "1" },
  { label: "Quotation Submitted", value: "2" },
  { label: "Qualified", value: "3" },
  { label: "Rejected", value: "4" },
  { label: "Awarded", value: "6" },
  { label: "Invoice Raised", value: "7" },

];

const supplierStatusOptions = [
  { label: "All", value: "" },
  { label: "Live", value: "1" },
  { label: "Quotation Submitted", value: "2" },
  { label: "Qualified", value: "3" },
  { label: "Rejected", value: "4" },
  { label: "Awarded", value: "6" },
  { label: "Invoice Raised", value: "7" },

];

const Dashboard = () => {
  const [rfq, setRFQ] = useState([]);
  const [order, setOrder] = useState([]);
  const [suppliers,setSuppliers]=useState([])
  const [products,setProducts]=useState([])
  const [loading, setLoading] = useState(false);
  const [tilesData, setTilesData] = useState([]);
  const [selectedTile, setSelectedTile] = useState("rfq"); // track selected tile
  const [selectedStatus, setSelectedStatus] = useState(""); // For supplier filter
  const navigate = useNavigate();
const [rfqSortConfig, setRFQSortConfig] = useState({
  key: "", // "due_date" or "status"
  direction: "asc", // "asc" or "desc"
});
  const [quotesSubmitted, setQuotedSubmitted] = useState([]);
  const [pendingReviews, setPendingReviews] = useState([]);
  const [activeOrders, setActiveOrders] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const statusColors = {
    5: "secondary",
    8: "warning",
    3: "success",
    4: "danger",
    10: "primary",
    6: "success",
    1: "success",
    0: "info",
    13:"success"
  }
  // -------------------- GET RFQ LIST ---------------------
const getRFQList = async () => {
  setLoading(true);
  try {
    const res = await apicall.get(
      `get_rfq?user_id=${userDetails?.id}`
    );

    let rfqList = res.data || [];

    rfqList = rfqList.filter(rfq =>
      rfq.RFQ_Data?.some(item => {
        const status = Number(item.status);

        // Buyer → status 0 & 1
        if (userDetails?.company_type_id === 1) {
          return status === 0 || status === 1;
        }

        // Supplier → only status 1
        if (userDetails?.company_type_id === 2) {
          return status === 1;
        }

        return false;
      })
    );

    setRFQ(rfqList);
    setTilesData(rfqList);

  } catch (e) {
    toast.error(e.message.replace("Error:", ""));
  } finally {
    setLoading(false);
  }
};




const handleRFQSort = (key) => {
  setRFQSortConfig((prev) => ({
    key,
    direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
  }));
};
const sortedRFQData = () => {
  let filteredRFQs = [...rfq];

  if (selectedStatus) {
    const selectedStatusNum = Number(selectedStatus);

    filteredRFQs = filteredRFQs.filter(item =>
      item.RFQ_Data?.some(rfqItem => Number(rfqItem.status) === selectedStatusNum)
    );
  }

  // Sort
  if (rfqSortConfig.key) {
    filteredRFQs.sort((a, b) => {
      let aValue, bValue;

      if (rfqSortConfig.key === "due_date") {
        aValue = new Date(a.responsible_date);
        bValue = new Date(b.responsible_date);
      } else if (rfqSortConfig.key === "status") {
        aValue = a.RFQ_Data?.[0]?.status || 0;
        bValue = b.RFQ_Data?.[0]?.status || 0;
      }

      if (aValue < bValue) return rfqSortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return rfqSortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }

  return filteredRFQs.map(item => {
    const statusCode = item.RFQ_Data?.[0]?.status || 0;
    const { label: statusLabel } = getStatusProps(Number(statusCode));
    const badgeColor = statusColors[statusCode] || "secondary";

    const createdByDisplay =
      userDetails?.company_type_id === 2
        ? `${item.created_by_name} - ${item.company_name || ""}`
        : item.created_by_name;

    return [
      item.display_id,
      createdByDisplay,
      item.title,
      new Date(item.responsible_date).toLocaleDateString(),
      <span className={`badge bg-${badgeColor}`} key={item.display_id}>
        {statusLabel}
      </span>,
    ];
  });
};




  // -------------------- GET ORDERS DATA ---------------------
  const getOrdersData = async () => {
    setLoading(true);
    try {
      const res = await apicall.get(`orders_filter/${userDetails?.id}`);
      setOrder(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };

    const getSuppliersData = async () => {
    setLoading(true);
    try {
      const res = await apicall.get(`suppliers/${userDetails?.id}`);
      setSuppliers(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };
      const getProducts = async () => {
    setLoading(true);
    try {
      const res = await apicall.get(`products/${userDetails?.id}`);
      setProducts(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  getRFQList();

  if (userDetails?.company_type_id === 1) {
    getOrdersData();
    getSuppliersData();
    getProducts();
  }

  if (userDetails?.company_type_id === 2) {
    getSupplierQuotes();
    getSupplierOrders();
    getPendReviews();
  }
}, []);


  // ------------------- FILTER BY STATUS -------------------
  const handleStatusChange = (e) => {
    const value = e.target.value;
    setSelectedStatus(value);
    getRFQList(value);
  };

const handleEdit = (rowIndexOrData) => {
  const selectedRFQ =
    typeof rowIndexOrData === "number"
      ? rfq[rowIndexOrData]
      : rfq.find((x) => x.display_id === rowIndexOrData[0]);

  if (!selectedRFQ) return toast.error("RFQ not found");

  navigate("/rfq", {
    state: {
      mode: "edit",
      formData: selectedRFQ,
    },
  });
};

const handleView = (rowIndexOrData) => {
  let selectedRow;

  if (typeof rowIndexOrData === "number") {
    switch (selectedTile) {
      case "rfq":
        selectedRow = rfq[rowIndexOrData];
        break;
      case "quotes":
        selectedRow = quotesSubmitted[rowIndexOrData];
        break;
      case "supplierOrders":
        selectedRow = activeOrders[rowIndexOrData];
        break;
      default:
        selectedRow = null;
    }
  } else {
    switch (selectedTile) {
      case "rfq":
        selectedRow = rfq.find((x) => x.display_rfq_id === rowIndexOrData[0]);
        break;
      case "quotes":
        selectedRow = quotesSubmitted.find((x) => x.rfq_id === rowIndexOrData.rfq_id);
        break;
      case "supplierOrders":
        selectedRow = activeOrders.find((x) => x.order_id === rowIndexOrData.order_id);
        break;
      default:
        selectedRow = null;
    }
  }

  if (!selectedRow) return toast.error("Data not found");
  switch (selectedTile) {
    case "rfq":
      navigate("/rfq", { state: { mode: "view", formData: selectedRow } });
      break;
    case "quotes":
      navigate(`/vendor_quatation_form/${selectedRow.rfq_id}`, {
        state: { rfq: selectedRow }, 
      });
      break;
    case "supplierOrders":
  navigate(`/vendor_order_details/${selectedRow.id_rfq}`, {
    state: { orders: selectedRow },
  });
  break;


    default:
      toast.error("No view available for this tile");
  }
};





// ------------------- TABLE DATA FORMATTING -------------------
const rfq_Data = rfq.map((item) => {
  const status = item.RFQ_Data?.[0]?.status;
  const badgeColor = statusColors[status] || "secondary";

  // Determine the "Created By" display
  const createdByDisplay =
    userDetails?.company_type_id === 2
      ? `${item.created_by_name} - ${item.company_name || ""}`
      : item.created_by_name;

  return [
    item.display_id,
    createdByDisplay,
    item.title,
    new Date(item.responsible_date).toLocaleDateString(),
    <span className={`badge bg-${badgeColor}`} key={item.display_id}>
      {item.RFQ_Data?.[0]?.status === "0"
        ? "Draft"
        : item.RFQ_Data?.[0]?.status_name === "RFQ Created"
        ? "Requested"
        : item.RFQ_Data?.[0]?.status_name || "N/A"}
    </span>,
  ];
});


  const order_Data = order.map((item) => {
    const badgeColor = statusColors[item.status] || "secondary";
    return [
      `RFQ_2025-${item.display_id}`,
      `ORDER_2025-${item.order_id}`,
      item.title,
      new Date(item.delivery_date).toLocaleDateString(),
      <span className={`badge bg-${badgeColor}`}>
        {item?.name || "N/A"}
      </span>
    ];
  });
const supplierQuotes_Data = quotesSubmitted.map(item => [
  item.display_rfq_id,
  item.company_info?.name || "-",
  item.title,
  new Date(item.responsible_date).toLocaleDateString(),
  item.total_price,
  <StatusBadge status={item.supplier_status} />,
]);


const supplierOrders_Data = activeOrders.map(item => [
  item.display_id,
  item.name || "-",
  item.title,
  new Date(item.delivery_date).toLocaleDateString(),
  item.total_price,
  <StatusBadge status={item.status} />,

]);

const supplierCommonHeaders = [
  "RFQ ID",
  "Company",
  "Title",
  "Deadline",
  "Total Price",
  "Status",
];


const bookingHeaders = [
  "RFQ ID",
  "Created by",
  "Title",
  <span
    style={{ cursor: "pointer" }}
    onClick={() => handleRFQSort("due_date")}
  >
    Due Date 
     <span style={{ fontSize: "12px", color: "#888" }}>↑↓</span>
    {/* {rfqSortConfig.key === "due_date" ? (rfqSortConfig.direction === "asc" ? "↑" : "↓") : ""} */}
  </span>,
  <span
    style={{ cursor: "pointer" }}
    onClick={() => handleRFQSort("status")}
  >
    Status
         <span style={{ fontSize: "12px", color: "#888",fontWeight:"600px" }}>↑↓</span>

     {/* {rfqSortConfig.key === "status" ? (rfqSortConfig.direction === "asc" ? "↑" : "↓") : ""} */}
  </span>,
];
  const order_header = ["RFQ ID","ORDER ID", "Title", "Date", "Status"];
const supplier_headers = ["Company","Address","Supported Products"];

const supplier_Data = suppliers.map((item) => [
  item.company_name,
  item.company_address,
 item.supported_categories
]);

const product_headers = ["Product Name","Items"]
const product_Data = products.map((item) => [
  item.product_name,
  item.items,
]);
const [supplierTableData, setSupplierTableData] = useState([]);
const supplierTableHeaders = [
  "RFQ ID",
  "Deadline",
  "Company",
  "Title",
  "Total Price",
];
const formatSupplierTable = (list = []) =>
  list.map(item => ({
    rfqId: item.display_id,
    date: new Date(item.responsible_date).toLocaleDateString(),
    company: item.name || "-",
    title: item.title,
    amount: `₹ ${item.total_price?.toLocaleString() || 0}`
  }));


const getSupplierQuotes = async () => {
  setLoading(true);
  try {
    const res = await apicall.get(`getActiveRFQ/${userDetails.id}`);

    const filteredData = res?.data?.filter(rfq => Number(rfq?.supplier_status) === 2);
    setSupplierTableData(formatSupplierTable(filteredData || []));
    setQuotedSubmitted(filteredData || []);
  } finally {
    setLoading(false);
  }
};


const getSupplierOrders = async () => {
  setLoading(true);
  try {
    const res = await apicall.get(`orders/${userDetails?.id}`);

    const orders = res?.data || [];

    const allowedStatuses = ["3", "6", "7", "8", "9", "10"];

    const filteredData = orders.filter(rfq =>
      allowedStatuses.includes(rfq?.status)
    );

    const formatted = formatSupplierTable(filteredData);

    setSupplierTableData(formatted);
    setActiveOrders(filteredData);

  } finally {
    setLoading(false);
  }
};


const getPendReviews = async () => {
  setLoading(true);
  try {
    const res = await apicall.get(`getPendingReviews/${userDetails.id}`);
    setSupplierTableData(formatSupplierTable(res.data || []));
    setPendingReviews(res.data || []);
  } finally {
    setLoading(false);
  }
};


  // ------------------- HANDLE TILE CLICK -------------------
const handleOverviewClick = (tile) => {
  setSelectedTile(tile);

  // Buyer flow
  if (userDetails?.company_type_id === 1) {
    if (tile === "rfq") getRFQList();
    if (tile === "orders") getOrdersData();
    if (tile === "suppliers") getSuppliersData();
    if (tile === "products") getProducts();
  }

  // Supplier flow
  if (userDetails?.company_type_id === 2) {
    if (tile === "rfq") getRFQList();
    if (tile === "quotes") getSupplierQuotes();
    if (tile === "pendingReviews") getPendReviews();
    if (tile === "supplierOrders") getSupplierOrders();
  }
};

 const overviewTiles =
    userDetails?.company_type_id === 1
      ? [
          { title: "Active RFQs", value: tilesData.length, tile: "rfq", icon: "📄", bg: "#EAF3FF", ibg: "#2c71c1ff" },
          { title: "Active Orders", value: order.length, tile: "orders", icon: "🛒", bg: "#F2FFF4", ibg: "#3fca69ff" },
          { title: "Suppliers", value: suppliers.length, tile: "suppliers", icon: "🏢", bg: "#FBF3FF", ibg: "#8b45d0ff" },
          { title: "Products", value: products.length, tile: "products", icon: "📦", bg: "#FFF8F0", ibg: "#dc953dff" },
        ]
      : [
         
  { title: "Active RFQs", value: rfq.length, tile: "rfq", icon: "📄", bg: "#EAF3FF", ibg: "#2c71c1ff" },
  { title: "Quotations Submitted", value: quotesSubmitted.length, tile: "quotes", icon: "🧾", bg: "#FFF4E5", ibg: "#f59e0b" },
  { title: "Pending Reviews", value: pendingReviews.length, tile: "pendingReviews", icon: "⏱️", bg: "#F3E8FF", ibg: "#8b5cf6" },
  { title: "Orders Won", value: activeOrders.length, tile: "supplierOrders", icon: "🏆", bg: "#F2FFF4", ibg: "#22c55e" },
  ];
const getSupplierTableData = () => {
  switch (selectedTile) {
    case "quotes":
      return supplierQuotes_Data;
    case "pendingReviews":
      return supplierPending_Data;
    case "supplierOrders":
      return supplierOrders_Data;
     case "rfq": // Active RFQs for supplier
    default:
      // Use the same sortedRFQData logic as buyer
      return sortedRFQData();
  }
};
const supplierPending_Data = pendingReviews.map(item => [
  item.display_rfq_id,
  item.company_info?.name || "-",
  item.title,
  new Date(item.responsible_date).toLocaleDateString(),
  item.total_price,
    <StatusBadge status={item.status} />,
]);

  return (
    
    <div className="container-fluid p-4">
       <div className="mb-4">
        <h5 className="mb-3">Overview</h5>
        <div className="row g-3">
          {overviewTiles.map((t, i) => (
            <div key={i} className="col-md-3 col-sm-6">
              <div
                className="card shadow-sm border-0 h-100 d-flex flex-column justify-content-between"
  style={{
    borderRadius: 12,
    backgroundColor: t.bg,
    padding: 18,
    cursor: "pointer"
  }}
                onClick={() => handleOverviewClick(t.tile)}
              >
                <div className="d-flex justify-content-between mb-2">
                 <p className="mb-0 fw-semibold overview-title">
  {t.title}
</p>


                  <div style={{ background: t.ibg, width: 30, height: 30, borderRadius: 5, fontSize: 20 }} className="d-flex align-items-center justify-content-center">
                    {t.icon}
                  </div>
                </div>
                <h4>{t.value}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Table Section */}
      <div className="card shadow-sm border-0">
        <div className="card-body">
<div className="rfq-card-header mb-3">
          <div>
       <h5>
 {selectedTile === "rfq"
            ? "Active RFQs"
    : selectedTile === "quotes"
    ? "Quotations Submitted"
    : selectedTile === "pendingReviews"
    ? "Pending Reviews"
    : selectedTile === "supplierOrders"
    ? "Orders Won"
    : selectedTile === "orders"
    ? "Active Orders"
    : selectedTile === "suppliers"
    ? "Suppliers"
    : selectedTile === "products"
    ? "Products"
    : ""}
</h5>
        <small>
          {selectedTile === "rfq"
            ? "View active RFQs"
    : selectedTile === "quotes"
            ? "View submitted quotations"
            : selectedTile === "pendingReviews"
            ? "View pending reviews"
            : selectedTile === "supplierOrders"
            ? "View orders won"
            : selectedTile === "orders"
            ? "View active orders"
            : selectedTile === "suppliers"
            ? "Suppliers who quoted your RFQs"
            : selectedTile === "products"
            ? "Products under RFQs / Orders"
            : ""}
        </small>
      </div>

            {/* Create Button Only for Buyer and RFQs */}
            {selectedTile === "rfq" && userDetails?.company_type_id === 1 && (
              <button
                className="btn btn-danger px-4"
                onClick={() => navigate("/rfq", { state: { mode: "add" } })}
              >
                Create RFQ
              </button>
            )}
          </div>

  <div className="mb-3 d-flex justify-content-end">
    <DropdownButton
      id="status-filter"
      variant="outline-secondary"
      title={
        selectedStatus
          ? getStatusProps(Number(selectedStatus)).label
          : "All Statuses"
      }
    >
      {/* Wrap all items in a scrollable div */}
      <div style={{ maxHeight: "200px", overflowY: "auto" }}>
        {/* All Statuses option */}
        <Dropdown.Item onClick={() => setSelectedStatus("")}>
          All Statuses
        </Dropdown.Item>

        {Object.entries(RFQ_STATUS)
          .filter(([key, value]) => {
            const numericKey = Number(key);
            if (userDetails?.company_type_id === 1) return true;

            if (userDetails?.company_type_id === 2)
              return numericKey !== 0 && numericKey !== 12;

            return true;
          })
          .map(([key, value]) => (
            <Dropdown.Item
              key={key}
              onClick={() => setSelectedStatus(key)}
            >
              {value.label}
            </Dropdown.Item>
          ))}
      </div>
    </DropdownButton>
  </div>






          {/* Table */}
          {loading ? (
            <Skeleton count={5} height={40} />
          ) : (
            
        <Table
  headers={
    userDetails?.company_type_id === 2 && selectedTile !== "rfq"
      ? supplierCommonHeaders
      : selectedTile === "orders"
      ? order_header
      : selectedTile === "suppliers"
      ? supplier_headers
      : selectedTile === "products"
      ? product_headers
      : bookingHeaders
  }
  data={
    userDetails?.company_type_id === 2 && selectedTile !== "rfq"
      ? getSupplierTableData()
      : selectedTile === "orders"
      ? order_Data
      : selectedTile === "suppliers"
      ? supplier_Data
      : selectedTile === "products"
      ? product_Data
      : sortedRFQData()
  }
  pagination
  recordsCount={5}

  Action={
    userDetails?.company_type_id === 1
      ? selectedTile === "rfq"
        ? { edit: handleEdit, view: handleView }
        : null
      : userDetails?.company_type_id === 2
      ? selectedTile !== "pendingReviews"
        ? handleView
        : null
      : null
  }

  actionType={
    userDetails?.company_type_id === 1
      ? selectedTile === "rfq"
        ? "edit-view"
        : null
      : userDetails?.company_type_id === 2
      ? selectedTile !== "pendingReviews"
        ? "view"
        : null
      : null
  }
/>



          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
